"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FREE_TRIAL_PLAN_KEYS = exports.PLAN_CATALOG = exports.PLAN_CARD_CONTEXTS = exports.FREE_TRIAL_DAYS = exports.FREE_PLAN_KEY = exports.PLAN_KEYS = void 0;
exports.metronomeDurationToDays = metronomeDurationToDays;
exports.deriveFreeTrialDays = deriveFreeTrialDays;
exports.isPlanKey = isPlanKey;
exports.resolvePlanDisplay = resolvePlanDisplay;
exports.PLAN_KEYS = ['no-subscription', 'access-only', 'dac-promo', 'small-teams'];
exports.FREE_PLAN_KEY = 'no-subscription';
exports.FREE_TRIAL_DAYS = 30;
const DAYS_PER_DURATION_UNIT = {
    DAYS: 1,
    WEEKS: 7,
    MONTHS: 30,
    YEARS: 365,
};
function metronomeDurationToDays(duration) {
    return duration.value * DAYS_PER_DURATION_UNIT[duration.unit];
}
function deriveFreeTrialDays(credits, designMonthProductId) {
    if (credits === undefined) {
        return 0;
    }
    const trialCredit = credits.find((credit) => credit.product_id === designMonthProductId);
    if (trialCredit === undefined) {
        return 0;
    }
    return trialCredit.access_schedule.schedule_items.reduce((days, item) => days + metronomeDurationToDays(item.duration), 0);
}
exports.PLAN_CARD_CONTEXTS = ['analyze', 'admin'];
exports.PLAN_CATALOG = [
    {
        kind: 'fixed',
        alias: 'dac-promo',
        contexts: ['analyze', 'admin'],
        hasFreeTrial: true,
        title: 'DAC Offer',
        subtitle: 'One design month each month for occasional analysis work.',
        badge: { label: 'Recommended', variant: 'recommended' },
        includes: [
            '1 design month per month',
            'Up to 2,000 components per design',
            '10 AI credits per user per month, up to 10 users',
        ],
        freeTrialInclude: '30-day free trial',
    },
    {
        kind: 'fixed',
        alias: 'small-teams',
        contexts: ['admin'],
        hasFreeTrial: false,
        title: 'Small Team',
        subtitle: 'Three design months each month for regular analysis work.',
        badge: null,
        includes: [
            '3 design months per month',
            'Up to 2,000 components per design',
            '10 AI credits per user per month, up to 20 users',
        ],
    },
    {
        kind: 'fixed',
        alias: 'access-only',
        contexts: ['admin'],
        hasFreeTrial: false,
        title: 'Access Only',
        subtitle: 'Keep access to designs you have already analyzed, without running new analysis.',
        badge: null,
        includes: ["Access designs you've analyzed", 'No new analysis', '10 AI credits per month, org-wide'],
    },
    {
        kind: 'enterprise',
        alias: 'enterprise',
        contexts: ['analyze', 'admin'],
        hasFreeTrial: false,
        title: 'Enterprise',
        subtitle: 'Custom pricing for large designs and high-volume teams.',
        badge: { label: 'Enterprise', variant: 'enterprise' },
        includes: [
            'Custom design month volume',
            'Large and complex designs',
            'High-volume team usage',
            'Dedicated support',
        ],
    },
    {
        kind: 'fixed',
        alias: 'no-subscription',
        hasFreeTrial: false,
        title: 'Free — platform access',
        subtitle: 'Access to the Cadstrom platform without analysis capabilities.',
        badge: null,
        includes: ['Platform access', 'One-time grant of 10 AI credits', 'Upgrade whenever you are ready to analyze'],
    },
];
exports.FREE_TRIAL_PLAN_KEYS = exports.PLAN_KEYS.filter((key) => exports.PLAN_CATALOG.some((entry) => entry.alias === key && entry.hasFreeTrial));
function isPlanKey(alias) {
    return exports.PLAN_KEYS.includes(alias);
}
function resolvePlanDisplay(alias, withFreeTrial) {
    const entry = exports.PLAN_CATALOG.find((candidate) => candidate.alias === alias);
    if (entry === undefined) {
        return { title: alias, subtitle: '', badge: null, includes: [] };
    }
    const { title, subtitle, badge, includes, freeTrialInclude } = entry;
    return {
        title,
        subtitle,
        badge,
        includes: withFreeTrial && freeTrialInclude !== undefined ? [...includes, freeTrialInclude] : includes,
    };
}
//# sourceMappingURL=plan-catalog.js.map